import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';

export default function DeleteRecordButton({ onClick }: any) {
  return (
    <DeleteOutlined style={{ color: 'red', fontSize: 18 }} onClick={onClick} />
  );
}
